export default __webpack_public_path__ + "static/media/BR.73558c82.png";